import { ErrorEvent } from '@sentry/types';

let failedAxiosUrl: string | undefined;

interface AxiosErrorStub {
    isAxiosError: boolean;
    config: {
        url: string;
    };
}

export const prepareAxiosErrorDataInterceptor =
    (sentryEnabled: boolean) =>
    (error: AxiosErrorStub | undefined | null): void => {
        if (sentryEnabled && error && error.isAxiosError) {
            failedAxiosUrl = error.config.url;
        }
    };

const pushAxiosDataToSentry = (event: ErrorEvent): ErrorEvent => {
    if (failedAxiosUrl) {
        if (!event.extra) {
            event.extra = {};
        }
        if (!event.tags) {
            event.tags = {};
        }

        event.extra.failedAxiosUrl = failedAxiosUrl;
        event.tags.failedAxiosUrl = failedAxiosUrl;
        failedAxiosUrl = undefined;
    }

    return event;
};

export default pushAxiosDataToSentry;
